export const MY_GOUSTO_INTENTS = {
  startOneOffOrder: 'start_one_off_order',
  reactivateSubscription: 'reactivate_subscription',
  editRecipes: 'edit_recipes',
  viewCollection: 'view_collection',
  addToOrder: 'add_to_order',
  pastDeliveries: 'past_deliveries',
  getHelp: 'get_help',
  viewCookbookRecipe: 'view_cookbook_recipe',
} as const
